<template>
  <div class="structure" v-for="item in table.data" :key="item.id">
    <a-breadcrumb separator=">">
      <a-breadcrumb-item
        v-for="(breadcrum, index) in breadcrumbList"
        :key="index"
        @click="handleToStructure(index)"
      >
        <span>{{ breadcrum.structureName }}</span>
      </a-breadcrumb-item>
    </a-breadcrumb>

    <template
      v-if="showStructure && showStructure.children && showStructure.children.length > 0"
    >
      <structure-node
        :structureData="showStructure.children"
        @handleUpdateStructure="handleUpdateStructure"
      ></structure-node>
    </template>

    <template
      v-if="showStructure && showStructure.userList && showStructure.userList.length > 0"
    >
      <staff :staffList="showStructure.userList" @handleSelectUser="handleSelectUser"></staff>
    </template>
  </div>

  <structrue-form ref="structrueFormRef"></structrue-form>
</template>

<script>
import { computed, defineComponent, reactive, ref } from "vue";
import { useTable } from "@/views/notice/serve/table";
import {
  deleteStructure,
  getStructure,
  saveStructure,
} from "@/request/view/personal";
import structureNode from "@/views/personnelManagement/component/structureNode/index.vue";
import staff from "@/views/personnelManagement/component/structure/person.vue";
import structrueForm from "@/views/personnelManagement/component/structure/form.vue";
import { EditOutlined } from "@ant-design/icons-vue";
import { useStore } from "vuex";

export default defineComponent({
  components: { structureNode, staff, EditOutlined, structrueForm },
  setup(props, context) {
    const { structureId } = useStore().state.user.user;
    const structureData = reactive([]);

    const {
      requestConfig,
      table,
      requestPayload,
      initPayload,
      getListData,
      searchData,
      deleteRecords,
    } = useTable();

    initPayload({
      id: structureId,
    });

    requestConfig.pull_fn = getStructure;
    // 面包屑列表
    const breadcrumbList = reactive([]);
    // 面包屑展示数据
    const showStructure = computed(
      () => breadcrumbList[breadcrumbList.length - 1]
    );
    // 数据请求
    getListData({ unPagingRequest: true }).then(() => {
      breadcrumbList.length = 0;
      breadcrumbList.push(...table.data);
    });
    // 增加面包屑
    const handleUpdateStructure = (record) => {
      console.log(record);
      breadcrumbList.push(record);
    };
    // 面包屑跳转
    const handleToStructure = (targetIndex) => {
      const deleteIndex = targetIndex + 1;
      const deleteNum = breadcrumbList.length - targetIndex;
      if (deleteIndex === breadcrumbList.length) return;
      breadcrumbList.splice(deleteIndex, deleteNum);
      context.emit('handleSelectUser', null);
    };
    // 组织架构表单
    const structrueFormRef = ref();

    // 更新组织架构
    const handleUpdateStructureByForm = (type, data) => {
      structrueFormRef.value.handleUpdateModal(type, data);
    };

    const handleSelectUser = (user) => {
      context.emit('handleSelectUser', user);
    };

    return {
      table,
      handleSelectUser,
      handleToStructure,
      handleUpdateStructure,
      breadcrumbList,
      showStructure,
      structrueFormRef,
    };
  },
});
</script>

<style lang="less" scoped>
.structure {
  height: calc(100vh - 160px);
  overflow-y: scroll;
  padding-right: 10px;
}
.corporate-name {
  font-size: 20px;
  color: #23797c;
}
</style>
